export const proyectos = {
    title: {
        h2: "CONOCE MÁS DE CERCA",
        h3: "NUESTRO TRABAJO",
    },
    categories: [
        "INDUSTRIAL",
        "RESIDENCIAL",
        "COMERCIAL",
        "RESTAURACIÓN",
        "PINTURA",
        "LIMPIEZA",
        "PUBLICIDAD",
    ],
    images: {
        Industrial: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
        Residencial: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
        Comercial: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
        Restauración: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
        Pintura: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
        Limpieza: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
        Publicidad: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
    },
};

export const proyectosEn = {
    title: {
        h2: "GET TO KNOW UP CLOSE",
        h3: "OUR WORK",
    },
    categories: [
        "INDUSTRIAL",
        "RESIDENTIAL",
        "COMMERCIAL",
        "RESTORATION",
        "PAINTING",
        "CLEANING",
        "ADVERTISING",
    ],
    images: {
        Industrial: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
        Residential: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
        Commercial: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
        Restoration: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
        Painting: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
        Cleaning: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
        Advertising: [
            { id: 1, src: "/assets/imgs/proyectos/industrial/1.jpg", alt: "1" },
            { id: 2, src: "/assets/imgs/proyectos/industrial/2.png", alt: "2" },
            { id: 3, src: "/assets/imgs/proyectos/industrial/3.png", alt: "3" },
            { id: 4, src: "/assets/imgs/proyectos/industrial/4.png", alt: "4" },
            { id: 5, src: "/assets/imgs/proyectos/industrial/5.png", alt: "5" },
            { id: 6, src: "/assets/imgs/proyectos/industrial/6.png", alt: "6" },
            { id: 7, src: "/assets/imgs/proyectos/industrial/7.jpg", alt: "7" },
            { id: 8, src: "/assets/imgs/proyectos/industrial/8.jpg", alt: "8" },
            { id: 9, src: "/assets/imgs/proyectos/industrial/9.png", alt: "9" },
            { id: 10, src: "/assets/imgs/proyectos/industrial/10.png", alt: "10" },
        ],
    },
};

